var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthDarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4128_90798)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#141619",
    stroke: "#525F6B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.998 8V13.9133L20.996 16.1466L15.998 8Z",
    fill: "#81909E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 8L11 16.1466L15.9987 13.9133V8Z",
    fill: "#81909E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.998 19.979V23.997L20.9994 17.0776L15.998 19.979Z",
    fill: "#81909E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 23.997V19.9783L11 17.0776L15.9987 23.997Z",
    fill: "#81909E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.998 19.0485L20.996 16.1465L15.998 13.9146V19.0485Z",
    fill: "#81909E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.1465L15.9987 19.0485V13.9146L11 16.1465Z",
    fill: "#81909E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4128_90798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthDarkCircle);
export default __webpack_public_path__ + "static/media/eth-dark-circle.67fc6948b66600fd2474c93108093338.svg";
export { ForwardRef as ReactComponent };